import React from 'react';
import AppRouter from './routes';
import './App.css';

function App() {
  return <AppRouter />;
}

export default App; 